import React from 'react';
import Link from 'next/link';

export default function CTASection() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-card border border-primary/30 rounded-3xl p-12 card-glow-yellow relative overflow-hidden">
          <div className="absolute inset-0 opacity-5 hero-grid-bg pointer-events-none" />
          <div className="relative z-10">
            <div className="text-5xl mb-6">🍍</div>
            <h2 className="text-3xl font-extrabold text-foreground mb-4">
              Ready to Open Your<br />
              <span className="gradient-text-primary">First Case File?</span>
            </h2>
            <p className="text-muted-foreground text-lg mb-8 max-w-lg mx-auto">
              Join thousands of fans already competing in the Psych Case Files. 
              Create your Detective Agency ID and start earning XP today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/sign-up-login-screen"
                className="px-8 py-4 bg-primary text-primary-foreground text-base font-bold rounded-2xl hover:bg-primary/90 transition-all duration-150 active:scale-95"
              >
                Create Your Detective ID →
              </Link>
              <Link
                href="/sign-up-login-screen"
                className="px-8 py-4 border border-border text-foreground text-base font-semibold rounded-2xl hover:border-primary/50 hover:bg-primary/5 transition-all duration-150"
              >
                Sign In to Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}